import { useContext } from "react"
import { useMutation, useQueryClient } from "react-query"
import AuthContext from "../Context/auth_provider.jsx"
import useAxiosPrivate from "./useAxiosPrivate.js"

// Update Entity Hook
/* 
    Modifying entity where the client sends data that updates the entire resource.
*/
const useUpdateEntity = (page) => {
    const queryClient = useQueryClient()
    const { companyId, teamId } = useContext(AuthContext)
    const domain = teamId ? `/team/${teamId}` : `/corporate/${companyId}`

    const axiosPrivate = useAxiosPrivate()

    return useMutation(
        (data) =>
            axiosPrivate
                .put(`${domain}/${page}`, data)
                .then((response) => response),
        {
            onSuccess: () => {
                queryClient.invalidateQueries([page])
            },
        }
    )
}

export default useUpdateEntity
